export default __webpack_public_path__ + "d1406df7f9ce817ae0e5b3eb5f1bf1f3.png";